import { useTheme } from "../../framework/theme/mantine-passthroughs.js";
import { Box as Box$1, ScrollArea } from "../mantine-passthroughs/index.js";
import { Subtitle1 } from "../typography/Subtitle1.js";
import { useMediaQuery } from "../../hooks/mantine-passthroughs/index.js";
import { Drawer as Drawer$1 } from "../drawer/Drawer.js";
import modal_module_default from "./modal.module.js";
import { Flex, Modal } from "@mantine/core";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/modal/Modal.tsx
const Modal$1 = ({ title, titleColor, TitleIcon, children, opened, onClose, size, height = "auto", "data-testid": testId }) => {
	const isMobile = useMediaQuery(`(max-width: ${useTheme().breakpoints.sm})`);
	const header = title ? /* @__PURE__ */ jsxs(Flex, {
		gap: "xxs",
		align: "center",
		children: [TitleIcon, /* @__PURE__ */ jsx(Subtitle1, {
			color: titleColor,
			inline: true,
			children: title
		})]
	}) : null;
	if (isMobile) return /* @__PURE__ */ jsx(Drawer$1, {
		fullWidth: true,
		header,
		opened,
		onClose,
		height: "auto",
		position: "bottom",
		"data-testid": testId,
		children: /* @__PURE__ */ jsx(Box$1, {
			pt: title ? 0 : "md",
			pr: "md",
			pb: "md",
			pl: "md",
			children
		})
	});
	return /* @__PURE__ */ jsx(Modal, {
		size,
		title: header,
		opened,
		onClose,
		classNames: modal_module_default,
		transitionProps: { transition: "pop" },
		scrollAreaComponent: ScrollArea.Autosize,
		"data-testid": testId,
		__vars: { "--modal-content-height": `${height}` },
		children
	});
};

//#endregion
export { Modal$1 as Modal };